const VEHICLE_TYPES = {
    CATALOG: 'catalog',
    INVENTORY: 'inventory',
};

export default VEHICLE_TYPES;
